import images from "./images";

const doorIntro = {
    sub: "Discover Our Doors",
    heading: "Experience the Beauty of Quality Doors",
    description: [
        "At Windows & Doors, we're seeking dedicated individuals to join our team of security experts. Explore rewarding career opportunities in door installation, maintenance, and security services. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    ],
    points: [
        "Opportunities in Door Installation",
        "Assist in Security Operations",
        "Advanced Training Programs",
        "Security Situation Management",
        "Support in Security Measures",
    ],
    image: {
        src1: images.doorAbout1,
        src2: images.doorAbout2,
        alt1: "Door Image 1",
        alt2: "Door Image 2",
    },
};

const doorFaqs = [
  {
    id: 1,
    heading: "What are the different types of doors available?",
    content: "Explore the various types of doors, including entry doors, interior doors, patio doors, and more. Learn about their features, materials, and ideal applications.",
  },
  {
    id: 2,
    heading: "How is a door installed?",
    content: "Discover the step-by-step process of door installation, from measuring and preparing the opening to fitting and securing the door in place. Ensure a proper and efficient installation for optimal performance.",
  },
  {
    id: 3,
    heading: "What maintenance is required for doors?",
    content: "Learn about the essential maintenance tasks to keep your doors in top condition. From regular cleaning and lubrication to addressing minor issues promptly, proper maintenance ensures longevity and functionality.",
  },
  {
    id: 4,
    heading: "Do doors come with security features?",
    content: "Explore the security features available in modern doors, including sturdy locks, reinforced frames, and impact-resistant materials. Enhance your home's security and peace of mind with the right door features.",
  },
  {
    id: 5,
    heading: "Can doors be customized?",
    content: "Discover the customization options available for doors, such as different finishes, styles, and hardware choices. Personalize your doors to match your home's aesthetic and functional requirements.",
  },
];


const doors = [
    {
        id: 1,
        image: images.door1,
        title: "Entry Door",
        details: {
            material: "Wood, Steel, Fiberglass",
            styleDesign: "Panel Door, Flush Door, French Door",
            dimensions: "Standard Sizes Available",
            finishColor: "White, Oak, Mahogany",
            hardware: "Handles, Hinges, Locks",
            securityFeatures: "Deadbolts, Security Bars",
            energyEfficiency: "Insulated, Weather-stripping",
            soundproofing: "Acoustic Insulation, Seals",
            warranty: "5-Year Limited Warranty, Lifetime Warranty"
        },
        paragraphs: [
            "When you're looking for the perfect entry door for your home, our comprehensive selection and expert installation services ensure you'll find the ideal fit.",
            "Our team specializes in providing a wide selection of entry door styles and professional installation services. Whether you're seeking security, style, or energy efficiency, we have the expertise to meet your needs."
        ],
        gallery: [
            images.door1Gallery1,
            images.door1Gallery2,
            images.door1Gallery3,
            images.door1Gallery4,
            images.door1Gallery5,
            images.door1Gallery6,
        ],
        styles: [
            "Wide Selection of Entry Door Styles",
            "Professional Installation Services",
            "Customization Options Available"
        ],
        features: [
            "Expert Guidance in Choosing the Right Door",
            "High-Quality Entry Door Products",
            "Professional Installation and Finishing"
        ],
        specifications: [
            "Enhanced Curb Appeal and Security",
            "Energy-Efficient and Durable Solutions",
            "Increased Home Value"
        ]
    },
    {
        id: 2,
        image: images.door2,
        title: "French Door",
        details: {
            material: "Wood, Steel, Fiberglass",
            styleDesign: "Panel Door, Flush Door, French Door",
            dimensions: "Standard Sizes Available",
            finishColor: "White, Oak, Mahogany",
            hardware: "Handles, Hinges, Locks",
            securityFeatures: "Deadbolts, Security Bars",
            energyEfficiency: "Insulated, Weather-stripping",
            soundproofing: "Acoustic Insulation, Seals",
            warranty: "5-Year Limited Warranty, Lifetime Warranty"
        },
        paragraphs: [
            "When you're looking for the perfect French door for your home, our comprehensive selection and expert installation services ensure you'll find the ideal fit.",
            "Our team specializes in providing a wide selection of French door styles and professional installation services. Whether you're seeking elegance, natural light, or functionality, we have the expertise to meet your needs."
        ],
        gallery: [
            images.door2Gallery1,
            images.door2Gallery2,
            images.door2Gallery3,
            images.door2Gallery4,
            images.door2Gallery5,
            images.door2Gallery6,
        ],
        styles: [
            "Wide Selection of French Door Styles",
            "Professional Installation Services",
            "Customization Options Available"
        ],
        features: [
            "Expert Guidance in Choosing the Right Door",
            "High-Quality French Door Products",
            "Professional Installation and Finishing"
        ],
        specifications: [
            "Enhanced Curb Appeal and Interior Light",
            "Energy-Efficient and Durable Solutions",
            "Increased Home Value"
        ]
    },
    {
        id: 3,
        image: images.door3,
        title: "Sliding Door",
        details: {
            material: "Wood, Steel, Fiberglass",
            styleDesign: "Panel Door, Flush Door, French Door",
            dimensions: "Standard Sizes Available",
            finishColor: "White, Oak, Mahogany",
            hardware: "Handles, Hinges, Locks",
            securityFeatures: "Deadbolts, Security Bars",
            energyEfficiency: "Insulated, Weather-stripping",
            soundproofing: "Acoustic Insulation, Seals",
            warranty: "5-Year Limited Warranty, Lifetime Warranty"
        },
        paragraphs: [
            "Discover the ease and elegance of our premium sliding doors. Designed for both function and aesthetics, these doors effortlessly merge indoor comfort with outdoor access.",
            "Our sliding doors come in various styles and finishes, perfect for maximizing natural light while saving space. They are crafted for durability, smooth operation, and modern appeal."
        ],
        gallery: [
            images.door3Gallery1,
            images.door3Gallery2,
            images.door3Gallery3,
            images.door3Gallery4,
            images.door3Gallery5,
            images.door3Gallery6,
        ],
        styles: [
            "Contemporary Sliding Door Designs",
            "Space-Saving Configurations",
            "Tailored Finishes and Frame Options"
        ],
        features: [
            "Smooth Gliding Track System",
            "High Insulation for Energy Savings",
            "Secure Locking Mechanisms"
        ],
        specifications: [
            "Weather-Resistant Construction",
            "Large Glass Panels for Natural Light",
            "Available in Custom Sizes"
        ]
    },
    {
        id: 4,
        image: images.door4,
        title: "Garage Door",
        details: {
            material: "Wood, Steel, Fiberglass",
            styleDesign: "Panel Door, Flush Door, French Door",
            dimensions: "Standard Sizes Available",
            finishColor: "White, Oak, Mahogany",
            hardware: "Handles, Hinges, Locks",
            securityFeatures: "Deadbolts, Security Bars",
            energyEfficiency: "Insulated, Weather-stripping",
            soundproofing: "Acoustic Insulation, Seals",
            warranty: "5-Year Limited Warranty, Lifetime Warranty"
        },
        paragraphs: [
            "Upgrade your home’s exterior with our robust and stylish garage doors. Designed for strength, security, and curb appeal, our garage doors are a perfect blend of performance and aesthetics.",
            "Whether you’re looking for traditional or modern designs, we offer customizable garage door options with durable materials and advanced insulation for optimal functionality year-round."
        ],
        gallery: [
            images.door4Gallery1,
            images.door4Gallery2,
            images.door4Gallery3,
            images.door4Gallery4,
            images.door4Gallery5,
            images.door4Gallery6,
        ],
        styles: [
            "Classic Raised Panel Designs",
            "Contemporary Flush Styles",
            "Carriage House Look"
        ],
        features: [
            "Smooth and Quiet Operation",
            "High R-Value Insulation",
            "Advanced Locking Systems"
        ],
        specifications: [
            "Weather-Sealed for All Seasons",
            "Impact-Resistant Panels",
            "Available with Smart Controls"
        ]
    },
    {
        id: 5,
        image: images.door5,
        title: "Panel Door",
        details: {
            material: "Wood, Steel, Fiberglass",
            styleDesign: "Panel Door, Flush Door, French Door",
            dimensions: "Standard Sizes Available",
            finishColor: "White, Oak, Mahogany",
            hardware: "Handles, Hinges, Locks",
            securityFeatures: "Deadbolts, Security Bars",
            energyEfficiency: "Insulated, Weather-stripping",
            soundproofing: "Acoustic Insulation, Seals",
            warranty: "5-Year Limited Warranty, Lifetime Warranty"
        },
        paragraphs: [
            "Bring timeless charm and strength to your interiors with our expertly crafted panel doors. These doors are designed to enhance both traditional and contemporary spaces.",
            "From solid construction to detailed craftsmanship, our panel doors offer excellent durability, security, and insulation, making them a favorite for homeowners seeking classic elegance."
        ],
        gallery: [
            images.door5Gallery1,
            images.door5Gallery2,
            images.door5Gallery3,
            images.door5Gallery4,
            images.door5Gallery5,
            images.door5Gallery6,
        ],
        styles: [
            "2-Panel and 6-Panel Designs",
            "Raised and Recessed Panel Options",
            "Customizable Panel Layouts"
        ],
        features: [
            "Solid Core for Better Soundproofing",
            "Classic Look with Modern Efficiency",
            "Durable Paint and Finish Choices"
        ],
        specifications: [
            "Moisture-Resistant Build",
            "Ideal for Interior and Exterior Use",
            "Custom Fit for Any Room"
        ]
    },
    {
        id: 6,
        image: images.door6,
        title: "Dutch Door",
        details: {
            material: "Wood, Steel, Fiberglass",
            styleDesign: "Panel Door, Flush Door, French Door",
            dimensions: "Standard Sizes Available",
            finishColor: "White, Oak, Mahogany",
            hardware: "Handles, Hinges, Locks",
            securityFeatures: "Deadbolts, Security Bars",
            energyEfficiency: "Insulated, Weather-stripping",
            soundproofing: "Acoustic Insulation, Seals",
            warranty: "5-Year Limited Warranty, Lifetime Warranty"
        },
        paragraphs: [
            "Add charm and versatility to your home with our custom Dutch doors. Perfect for both traditional and rustic aesthetics, these doors offer a unique split design.",
            "Dutch doors provide the flexibility of opening the top and bottom halves independently—great for ventilation while maintaining security and safety for children and pets."
        ],
        gallery: [
            images.door6Gallery1,
            images.door6Gallery2,
            images.door6Gallery3,
            images.door6Gallery4,
            images.door6Gallery5,
            images.door6Gallery6,
        ],
        styles: [
            "Split Door Design with Upper Opening",
            "Farmhouse and Cottage Style Options",
            "Custom Panel and Glass Configurations"
        ],
        features: [
            "Independent Top and Bottom Operation",
            "Secure Latching Systems",
            "Optional Glass Inserts for Natural Light"
        ],
        specifications: [
            "Ideal for Kitchens, Mudrooms, or Entrances",
            "Child and Pet Friendly Design",
            "Custom Sizing and Color Options Available"
        ]
    }

];

export { doorIntro, doorFaqs, doors };